export default __webpack_public_path__ + "static/blue-spinner-0ffb16e72f91d544881f7ecc6891147d.gif";